import React from 'react';
import PropTypes from 'prop-types';
import CircleButton from './CircleButton';
import DotsHorizontalIcon from '../icons/DotsHorizontalIcon';
import sizes from './sizes';
const DotsHorizontalButton = ({ disabled, onClick, title, id, className, size, }) => {
    return (React.createElement(CircleButton, { id: id, size: size, className: className, color: "gray", disabled: disabled, onClick: onClick, title: title },
        React.createElement(DotsHorizontalIcon, null)));
};
DotsHorizontalButton.propTypes = {
    id: PropTypes.string,
    size: PropTypes.oneOf(Object.values(sizes)),
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
    ]),
    disabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    title: PropTypes.string,
};
DotsHorizontalButton.defaultProps = {
    size: sizes.normal,
    disabled: false,
    title: '',
};
export default DotsHorizontalButton;
